"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Suggestion = /** @class */ (function () {
    function Suggestion(data, component) {
        this.data = {
            value: '',
            filters: [],
            filter_value: '',
            type: '',
            url: '',
            params: {},
        };
        this.data = Object.assign(this.data, data);
        this.component = component;
        this._position = this.data.position === undefined ? null : this.data.position;
    }
    Object.defineProperty(Suggestion.prototype, "params", {
        get: function () {
            return this.data.params;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Suggestion.prototype, "context", {
        get: function () {
            return this.data.filter_value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Suggestion.prototype, "url", {
        get: function () {
            return this.data.url;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Suggestion.prototype, "value", {
        get: function () {
            return this.data.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Suggestion.prototype, "normalizeValue", {
        get: function () {
            return (this.value + " " + this.context).toLowerCase();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Suggestion.prototype, "type", {
        get: function () {
            return this.data.type;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Suggestion.prototype, "position", {
        get: function () {
            return this._position;
        },
        set: function (position) {
            this._position = position;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Suggestion.prototype, "completion", {
        get: function () {
            return this.data.completion;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Suggestion.prototype, "filters", {
        // returns an array that includes this suggestion and
        // all of its sub-suggestions
        get: function () {
            var _this = this;
            var allFilters = [];
            allFilters.push(this);
            this.data.filters.forEach(function (filter) {
                var suggestion = new Suggestion((tslib_1.__assign(tslib_1.__assign({}, filter), { type: _this.type, value: _this.value, filter_value: filter.value })), _this.component);
                allFilters.push(suggestion);
            });
            return allFilters;
        },
        enumerable: true,
        configurable: true
    });
    Suggestion.prototype.positionEqual = function (other) {
        if (!other)
            return false;
        return this.position === other.position;
    };
    return Suggestion;
}());
exports.default = Suggestion;
//# sourceMappingURL=suggestion.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/site_search/suggestion.js
// module id = 8O63
// module chunks = 20 21